export const IDS_CAMPAIGNS_AND_EMAILS = {};
export const IDS_CAMPAIGNS = {
  MOST_ENGAGED_COMPANIES: "IDS_CAMPAIGNS_MOST_ENGAGED_COMPANIES",
  MOST_ENGAGED_PEOPLE: "IDS_CAMPAIGNS_MOST_ENGAGED_PEOPLE",
  CAMPAIGN_PERFORMANCE: "IDS_CAMPAIGNS_CAMPAIGN_PERFORMANCE",
  CAMPAIGN_KEYWORDS: "IDS_CAMPAIGNS_CAMPAIGN_KEYWORDS",
  OVERALL_ENGAGEMENT: "IDS_CAMPAIGNS_OVERALL_ENGAGEMENT",
  CREATE_NEW_EMAIL: "IDS_CAMPAIGNS_CREATE_NEW_EMAIL",
};
export const IDS_CAMPAIGNS_SMART_SOURCED = {};
export const IDS_CAMPAIGNS_AUDIENCE = {
  MESSAGE: "IDS_CAMPAIGNS_AUDIENCE_MESSAGE",
  CONTACTS: "IDS_CAMPAIGNS_AUDIENCE_CONTACTS",
  RECOMMENDATION: "IDS_CAMPAIGNS_AUDIENCE_RECOMMENDATION",
  LINK_LIST_BUTTON: "IDS_CAMPAIGNS_AUDIENCE_LINK_LIST_BUTTON",
  LINK_CONTACT_BUTTON: "IDS_CAMPAIGNS_AUDIENCE_LINK_CONTACT_BUTTON",
  LISTS_COLLECTION: "IDS_CAMPAIGNS_AUDIENCE_LISTS_COLLECTION",
  DASHBOARD_CAMPAIGN: "IDS_CAMPAIGNS_AUDIENCE_DASHBOARD_CAMPAIGN",
};
